// A live countdown for an announcement: to a fixed date, or to the next occurrence of a time of day.
// Only one copy runs a timer: the marquee's repeats (inside [inert]) are mirrors the first copy writes to.
// With reduced motion requested, the seconds are left out, so the text changes once a minute instead of every second.
if (!customElements.get('announcement-countdown')) {
	class AnnouncementCountdown extends HTMLElement {
		static reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

		connectedCallback() {
			if (this.closest('[inert]')) return;
			this.mirrors = Array.from(document.querySelectorAll('announcement-countdown')).filter((el) => el !== this && el.dataset.block === this.dataset.block && el.closest('[inert]'));
			this.target = this.nextTarget();
			if (!this.target) {
				this.setHidden();
				return;
			}
			this.tick();
			this.timer = setInterval(() => this.tick(), 1000);
		}
		disconnectedCallback() {
			clearInterval(this.timer);
		}
		// The end date, or with data-daily the same time of day tomorrow once today's has passed, skipping the days with no
		// cut-off (Sundays with data-skip-sunday, the dates in data-skip-dates). A run of skipped days longer than 60 hides it.
		nextTarget() {
			const end = new Date(this.dataset.end).getTime();
			if (Number.isNaN(end)) {
				return null;
			}
			const now = Date.now();
			if (this.dataset.daily !== 'true') {
				return end > now ? end : null;
			}
			const day = 86400000;
			let next = end > now ? end : end + (Math.floor((now - end) / day) + 1) * day;
			for (let tries = 0; this.isSkipped(next); tries++) {
				if (tries === 60) return null;
				next += day;
			}
			return next;
		}
		// Weekday and date in the countdown's own time zone (the end's offset), not the shopper's.
		isSkipped(time) {
			if (this.skipDates === undefined) {
				const offset = /([+-])(\d{2}):?(\d{2})$/.exec(this.dataset.end);
				this.offset = offset ? (offset[1] === '-' ? -1 : 1) * (offset[2] * 60 + Number(offset[3])) * 60000 : /z$/i.test(this.dataset.end) ? 0 : -new Date(this.dataset.end).getTimezoneOffset() * 60000;
				this.skipDates = new Set((this.dataset.skipDates || '').split(/[\s,]+/).filter((date) => /^\d{4}-\d{2}-\d{2}$/.test(date)));
			}
			const local = new Date(time + this.offset);
			return (this.dataset.skipSunday === 'true' && local.getUTCDay() === 0) || this.skipDates.has(local.toISOString().slice(0, 10));
		}
		setHidden() {
			[this, ...this.mirrors].forEach((el) => {
				el.hidden = true;
			});
		}
		tick() {
			let left = Math.floor((this.target - Date.now()) / 1000);
			if (left < 0) {
				this.target = this.nextTarget();
				if (!this.target) {
					this.setHidden();
					clearInterval(this.timer);
					return;
				}
				left = Math.floor((this.target - Date.now()) / 1000);
			}
			const pad = (value) => String(value).padStart(2, '0');
			const days = Math.floor(left / 86400);
			const seconds = AnnouncementCountdown.reducedMotion.matches ? '' : `:${pad(left % 60)}s`;
			const text = `${days > 0 ? `${days}d ` : ''}${pad(Math.floor((left % 86400) / 3600))}h:${pad(Math.floor((left % 3600) / 60))}m${seconds}`;
			[this, ...this.mirrors].forEach((el) => {
				if (text !== el.textContent) {
					el.textContent = text;
				}
				el.dataset.ready = '';
			});
		}
	}
	customElements.define('announcement-countdown', AnnouncementCountdown);
}
